'use client';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import { memo } from 'react';
import ProductCard from '@components/Cards/ProductCard';
import Section from '@repo/ui/src/components/Section';
import { ButtonStyleEnum } from '@enums/button-enums';
import useProducts from '@hooks/product/useProducts';

// eslint-disable-next-line react/display-name
const RecommendedProducts = memo(({ saleText, newText, addToCartText, _data, outOfStockText }) => {
  const smAndUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  const { products } = useProducts(_data);

  return (
    <Section texture gutterX={!!smAndUp}>
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-stretch tw-pb-6 md:tw-pb-20">
        <Grid container>
          {products?.length > 0 &&
            products.map((product) => (
              <Grid
                item
                key={product?.sku}
                xs={12}
                sm={6}
                lg={3}
                className="tw-border tw-border-warm-200"
              >
                <ProductCard
                  product={product}
                  saleText={saleText}
                  newText={newText}
                  addToCartText={addToCartText}
                  buttonStyle={ButtonStyleEnum.Secondary}
                  outOfStockText={outOfStockText}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    </Section>
  );
});

export default RecommendedProducts;
